import AppConstants from '../config/app.constants';

let LocationDeliveryService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/location-delivery`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };


    let getLocationDeliveryDetails = (locationId) => {
        return $http
            .get(AppConstants.api + `/location-delivery/${encodeURIComponent(locationId)}`)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        getLocationDeliveryDetails
    };
};

LocationDeliveryService.$inject = ['$http', '$q']

export default LocationDeliveryService;


// WEBPACK FOOTER //
// ./client/app/services/location-delivery.service.js